const DOM = {};

const cacheDOM = () => {
    DOM.formParent = document.querySelectorAll('.generic-form');
    DOM.formModal = document.querySelectorAll('.popup-form');

    // Set Callback function to be executed when observer find jForm loaded asynchronously
    // eslint-disable-next-line func-names
    const observer = new MutationObserver(function(mutations) {
        // eslint-disable-next-line func-names
        mutations.forEach(function(mutation) {
            for (let i = 0; i < mutation.addedNodes.length; i += 1) {
                const node = mutation.addedNodes[i];

                if (
                    node.classList !== undefined &&
                    node.classList.contains('jForm')
                ) {
                    DOM.form = node;
                    DOM.form.selectProgramme = DOM.form.querySelectorAll(
                        'select[name="Programme__c"]'
                    );
                    DOM.form.selects = DOM.form.querySelectorAll(
                        'select.jForm__input:not([name=Programme__c])'
                    );
                    DOM.form.selects.forEach((select) =>
                        select.closest('.jForm__row').classList.add('active')
                    );
                    DOM.form.inputs = DOM.form.querySelectorAll(
                        'input.jForm__input:not([type=tel])'
                    );
                    DOM.form.textareas = DOM.form.querySelectorAll(
                        'textarea.jForm__textarea'
                    );
                    DOM.form.selectProgramme.forEach((select) => {
                        // eslint-disable-next-line no-use-before-define
                        select.firstElementChild.innerText = '';
                    });
                    // eslint-disable-next-line no-use-before-define
                    bindEvents();
                }
            }
        });
    });

    DOM.formParent.forEach((parent) => {
        observer.observe(parent, {
            childList: true,
            subtree: true,
        });
    });

    DOM.formModal.forEach((parent) => {
        observer.observe(parent, {
            childList: true,
            subtree: true,
        });
    });
};

const bindEvents = () => {
    DOM.form.inputs.forEach((input) =>
        input.addEventListener('focus', () => {
            input.closest('.jForm__row').classList.add('active');
        })
    );
    DOM.form.textareas.forEach((input) =>
        input.addEventListener('focus', () => {
            input.closest('.jForm__row').classList.add('active');
        })
    );
    DOM.form.inputs.forEach((input) =>
        input.addEventListener('blur', () => {
            if (input.value === '')
                input.closest('.jForm__row').classList.remove('active');
        })
    );
    DOM.form.textareas.forEach((input) =>
        input.addEventListener('blur', () => {
            if (input.value === '')
                input.closest('.jForm__row').classList.remove('active');
        })
    );
    DOM.form.selectProgramme.forEach((input) =>
        input.addEventListener('change', () => {
            input.closest('.jForm__row').classList.add('active');
        })
    );
};

const init = () => {
    cacheDOM();
};

const form = { init };
export default form;
